export const devicesMinWidth = {
  /**
   * `320px`
   */
  mobileS: '(min-width: 320px)',

  /**
   * `375px`
   */
  mobileM: '(min-width: 375px)',

  /**
   * `425px`
   */
  mobileL: '(min-width: 425px)',

  /**
   * `768px`
   */
  tablet: '(min-width: 768px)',

  /**
   * `1024px`
   */
  laptop: '(min-width: 1024px)',

  /**
   * `1440px`
   */
  laptopL: '(min-width: 1440px)',

  /**
   * `2560px`
   */
  desktop: '(min-width: 2560px)',
}
